module.exports = __webpack_public_path__ + "static/media/bg3_md.3e0e6c09.webp";